<template>
    <v-card flat>
        <v-card-text>
            <div class="d-flex flex-column flex-md-row align-center justify-center">
                <span class="font-weight-bold mr-6 text">
                    {{ selectedItems.length }} Iten(s) selecionados:
                </span>
                <div class="d-flex flex-wrap">
                    <template v-for="action in actions">
                        <v-tooltip :key="action.name" bottom :color="action.canPerform(selectedItems) ? 'transparent' : 'dark'">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on">
                                    <v-btn
                                            v-bind="attrs"
                                            color="primary"
                                            class="mr-2 mt-1 mb-1 text-none"
                                            :disabled="!action.canPerform(selectedItems)"
                                            @click="action.perform(selectedItems)"
                                    >
                                        <v-icon left>{{ action.icon }}</v-icon>
                                        {{ action.name }}
                                    </v-btn>
                                </div>
                            </template>

                            <span v-if="!action.canPerform(selectedItems)">
                                Uma ou mais propostas selecionadas não permitem esta ação.
                            </span>
                        </v-tooltip>
                    </template>
                </div>
            </div>
        </v-card-text>

        <DialogFormaPagamento
                @fechar="fecharDialogTrocarFormaPagamento"
                v-model="exibir_troca_pagamento"
                :pedido="pedidoSelecionado"
                :propostas-selecionadas="selectedItems"
                v-if="exibir_troca_pagamento"
        />
    </v-card>
</template>

<script>
  import { get } from 'lodash'
  import { permiteReenviarPagamento, permiteReenviarContrato, permiteAlterarFormaPagamento } from '../../../helpers/validacao_acoes_carrinho'
  import enviarBoletoMixin from '../../../mixins/enviarBoletoMixin'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { notification } from '../../../plugins/helpers'
  import DialogFormaPagamento from '@/dialogs/DialogFormaPagamento'
  import { FormasPagamento } from '@/plugins/constants'
  import { mapState } from 'vuex'

  export default {
    name: 'IlhaAcoesMultiplas',
    components: {
      DialogFormaPagamento
    },
    mixins: [enviarBoletoMixin],
    props: {
      selectedItems: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        exibir_troca_pagamento: false,
        pedidoSelecionado: null,
        actions: [
          {
            name: 'REENVIAR PAGAMENTO',
            icon: 'mdi-send',
            canPerform: items => (items.length === 1 || (items.length >= 1 && items.every(item => item.forma_pagamento === FormasPagamento.Boleto))) && items.every(item => permiteReenviarPagamento(item.status_boleto, item.forma_pagamento, item.status_pedido)),
            perform: items => this.enviarPagamentos(items)
          },
          {
            name: 'REENVIAR CONTRATO',
            icon: 'mdi-file-edit',
            canPerform: items => items.length > 0 && items.every(item => permiteReenviarContrato(item.contrato)),
            perform: items => this.enviarContratos(items)
          },
          {
            name: 'ALTERAR FORMA DE PAGAMENTO',
            icon: 'mdi-cash-multiple',
            canPerform: items => items.length === 1 && items.every(item => permiteAlterarFormaPagamento(item.status_pedido, item.id_documento, item.job_carrinho_boleto_agendado, item.status_boleto)),
            perform: items => this.alterarFormaPagamento(items)
          }
        ]
      }
    },
    computed: {
      ...mapState(['exibe_reenvio_whatsapp'])
    },
    methods: {
      async enviarPagamentos (propostas) {
        if (propostas.length > 1) {
          this.enviarPagamentosMultiplos(propostas).then((response) => {
            notification(AlertTypes.SUCCESS, response.data.Msg)
            this.$emit('limparSelecao')
          }).catch(error => {
            const msgErro = get(error, 'response.data.Msg_Erro', 'Erro ao agendar o reenvio dos pagamentos!')
            notification(AlertTypes.ERROR, msgErro, '', false, false, true)
          })
          this.$emit('atualizaTela')
        } else {
          const item = propostas[0]
          if (item.forma_pagamento === 'boleto') {
            this.$emit('reenviarBoleto', item.id_pedido, item.cliente && item.cliente.email)
          } else if (item.forma_pagamento === 'link') {
            try {
              await this.$http.post('/proposta/linkpagamento/reenviar', {
                id_pedido: item.id_pedido,
                email: item.cliente && item.cliente.email
              })
              notification(AlertTypes.SUCCESS, 'Link de pagamento reenviado com sucesso!')
            } catch (error) {
              notification(AlertTypes.ERROR, 'Erro ao reenviar link de pagamento!', '', false, false, true)
            }
          }
          this.$emit('limparSelecao')
        }
      },
      async enviarContratos (propostas) {
        const item = propostas[0]
        const multiplas_cotas = propostas.length > 1
        this.$emit('reenviarContrato', item.contrato && item.contrato.id_contrato, item.whatsapp, this.exibe_reenvio_whatsapp, multiplas_cotas)
        this.$emit('limparSelecao')
      },
      alterarFormaPagamento (propostas) {
        if (propostas.length > 0) {
          this.pedidoSelecionado = propostas[0]
          this.exibir_troca_pagamento = true
        }
      },
      fecharDialogTrocarFormaPagamento () {
        this.exibir_troca_pagamento = false
        this.$emit('atualizaTela')
        this.$emit('limparSelecao')
      }
    }
  }
</script>

<style scoped>
.text-none {
  text-transform: none;
}
</style>
